<template>
  <div>
    <add-bank-statement-sidebar :data="sidebarData" :clients="clients" />
    <vx-card :title="$t('filters')" class="mb-8" style="background: white">
      <template slot="actions">
        <feather-icon
          @click="search"
          icon="FilterIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        />
        <feather-icon
          @click="resetFilters"
          icon="TrashIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        />
      </template>
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
          class="p-2"
        >
          <vs-row>
            <vs-col>
              <label for="">{{ $t('year') }}</label>
            </vs-col>
            <vs-col>
              <vs-input
                class="w-full"
                v-model="params.year"
                type="number"
                maxlength="4"
                min="2000"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
          class="p-2"
        >
          <vs-row>
            <vs-col>
              <label for="">{{ $t('month') }}</label>
            </vs-col>
            <vs-col>
              <v-select
                multiple
                v-model="params.month"
                :placeholder="$t('month')"
                :options="months"
                class="w-full"
                :reduce="(opt) => opt.id"
                label="text"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-xs="12"
          vs-sm="4"
          vs-lg="4"
          class="p-2"
        >
          <vs-row>
            <vs-col>
              <label for="">{{ $t('client') }}</label>
            </vs-col>
            <vs-col>
              <v-select
                :placeholder="$t('client')"
                multiple
                v-model="params.client_id"
                :options="clients"
                label="ShortName"
                :reduce="(client) => client.ClientId"
                class="w-full"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-xs="12"
          vs-sm="4"
          vs-lg="4"
          class="p-2"
        >
          <vs-row>
            <vs-col>
              <label class="text-sm opacity-75">{{ $t('bank') }}</label>
            </vs-col>
            <vs-col>
              <v-select
                multiple
                :placeholder="$t('bank')"
                v-model="params.bank_id"
                :options="banks"
                label="short_name"
                :reduce="(bank) => bank.id"
                class="w-full"
              />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vx-card>
    <vs-card>
      <div id="bank-statement-table-loading" class="vs-con-loading__container">
        <vs-row vs-type="flex" vs-justify="flex-end" class="mb-4">
          <vs-col
            vs-xs="12"
            vs-sm="2"
            vs-lg="2"
            class="p-2"
            vs-offset="0"
            v-if="hasPermission(['IU BANK STATEMENT ADD ACCOUNT'])"
          >
            <add-bank-account :clients="clients" :banks="banks" />
          </vs-col>
          <vs-col
            vs-xs="12"
            vs-sm="3"
            vs-lg="3"
            class="p-2" 
            v-if="hasPermission(['IU BANK STATEMENT EDIT'])"
          >
            <!-- <vs-button
              color="success"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="w-full"
              @click="add"
            >
              {{ $t('bank_statement') }}
</vs-button> -->
              <add-button  @click="add" :btnText="$t('bank_statement')"/>
            
          </vs-col>
          <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="p-2">
            <vs-input
              icon-pack="feather"
              icon="icon-search"
              :placeholder="$t('search')"
              v-model="params.search"
              class="w-full"
              @keypress.enter="search"
            />
          </vs-col>
          <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="p-2">
           <export-button :data="this.params" :url="'bank_statement/list/export/ISsha917893_12A2S_s883kj8'"/>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <bank-statement-table :data="statementList" @loadMore="loadMore" @edit-side-bar="edit" @sort="handleClickSort"/>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>
<script>
import AddBankStatementSidebar from '@/views/apps/bank_statement/AddBankStatementSidebar.vue'
import AddBankAccount from '@/views/apps/bank_statement/AddBankAccount.vue'
import BankStatementTable from '@/views/apps/bank_statement/BankStatementTable.vue'
import client from '@/http/requests/client'
import loading from '@/mixins/Loading.js'
import moduleStatement from '@/store/statement/moduleStatement.js'
import statement from '@/http/requests/statement'
import vSelect from 'vue-select'
import ExportButton from '@/views/components/ExportButton.vue'
import AddButton from '@/views/components/buttons/AddButton.vue'
export default {
  created() {
    if (!moduleStatement.isRegistered) {
      this.$store.registerModule('statement', moduleStatement)
      moduleStatement.isRegistered = true
    }
  },
  components: {
    AddBankAccount,
    AddBankStatementSidebar,
    BankStatementTable,
    ExportButton,
    AddButton,
    'v-select': vSelect
  },
  computed: {
    statementList() {
      return this.$store.state.statement.statementList
    }
  },
  data: () => ({
    sidebarData:{},
    banks: [],
    clients: [],
    months: [],
    params: {
      page: 1,
      search: '',
      year: '',
      month: '',
      client_id: null,
      bank_id: null
    },
    sortParams:{
        sort:'ASC',
        sortBy:'Cl.ClientName'
      }
  }),
  methods: {
    add() {
      this.sidebarData = {}
      this.$store.dispatch('toggleSidebar', 'add-bank-statement')
    },
    edit(data) {
      this.sidebarData = data
      this.$store.dispatch('toggleSidebar', 'add-bank-statement')
    },
    getBankList() {
      statement.bankList().then(res => {
        this.banks = res.data.banks
      })
    },
    getClients() {
      client.list().then(res => {
        this.clients = res.data.clients
      })
    },
    getMonths() {
      this.months = [
        { id: '01', text: '01' },
        { id: '02', text: '02' },
        { id: '03', text: '03' },
        { id: '04', text: '04' },
        { id: '05', text: '05' },
        { id: '06', text: '06' },
        { id: '07', text: '07' },
        { id: '08', text: '08' },
        { id: '09', text: '09' },
        { id: '10', text: '10' },
        { id: '11', text: '11' },
        { id: '12', text: '12' },
      ]
    },
    getStatementsList() {
      this.openLoading('bank-statement-table-loading')
      return this.$store.dispatch('statement/fetchStatementList', this.params).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    init() {
      this.getClients()
      this.getBankList()
      this.getMonths()
      this.search()
        
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getStatementsList()
        .then(res => { this.closeLoading('bank-statement-table-loading') })
        .catch(err => { this.closeLoading('bank-statement-table-loading') })
    },
    search() {
      this.params.page = 1
      this.getStatementsList()
        .then(res => { this.closeLoading('bank-statement-table-loading') })
        .catch(err => { this.closeLoading('bank-statement-table-loading') })
    },
    handleClickSort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
      this.search()
    },
    resetFilters() {
      this.params = {
        page: 1,
        search: '',
        year: '',
        month: '',
        client_id: null,
        bank_id: null
      }
      this.search()
    },
  },
  mixins: [loading],
  mounted() {
    this.init()
    /* statement.bankAccountList(this.params).then( res => {
      console.log(res.data)
    }) */
  }
}

</script>
